import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

export default function PendingApproval() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4 hero-gradient" data-testid="pending-approval-page">
      <div className="w-full max-w-lg text-center">
        <img src="/logo.png" alt="FutureXV Logo" className="h-16 mx-auto mb-6" />
        <div className="glass-card rounded-2xl p-10 border border-zinc-800">
          <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-10 h-10 text-yellow-400" />
          </div>
          <h1 className="text-3xl font-heading font-bold text-white mb-4" data-testid="pending-heading">
            Application Submitted
          </h1>
          <p className="text-zinc-300 text-lg mb-3" data-testid="pending-message">
            Thank you for registering with FutureXV!
          </p>
          <p className="text-zinc-400 mb-8">
            Your application is currently under review. An administrator will review and approve your account shortly. You will be able to log in once your application is approved.
          </p>
          <Button
            onClick={() => navigate('/')}
            className="btn-primary px-10 py-6"
            data-testid="pending-home-button"
          >
            Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
